import { VoidCallback } from '@deqo/foundation';
import React from 'react';
import { ContainerScope, resolve } from '../../Container';
import { EditorSession } from '../EditorSession';
import { Burdens } from '../extensibility/Burdens';
import { PointerInfo } from '../PointerInfo';

export class EdgingHandler extends React.Component<{ onEdge: VoidCallback }> {

    public static contextType = ContainerScope;

    @resolve(EditorSession) private session: EditorSession;

    private active = false;
    private time = 0;
    private trash = new Burdens();

    public render() {
        return null;
    }

    public componentDidMount() {
        this.trash.add(this.stop);
        this.trash.add(this.session.observe(PointerInfo, this.onPointerChange));
    }

    public componentWillUnmount() {
        this.trash.destroy();
    }

    private onPointerChange = (next: PointerInfo, prev: PointerInfo) => {
        if (next.edging && !prev.edging) this.start();
        if (!next.edging && prev.edging) this.stop();
    };

    private start = () => {
        this.active = true;
        this.time = 0;
        requestAnimationFrame(this.tick);
    };

    private stop = () => {
        this.active = false;
    };

    private tick = (tt: number) => {
        if (!this.active) return;
        const dt = tt - this.time;
        if (dt >= 32) {
            this.time = tt;
            this.props.onEdge();
        }
        requestAnimationFrame(this.tick);
    };
}
